import _classCallCheck from "@babel/runtime/helpers/classCallCheck";

var Node = function Node() {
  _classCallCheck(this, Node);
};

export { Node as default };